import { useEffect, useState } from "react";
import { Calendar, MapPin, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { FALLBACK_IMAGE } from "@/data/constants";

const fmt = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-US", { weekday: "short", year: "numeric", month: "long", day: "numeric" });
  } catch {
    return d;
  }
};

export default function Events() {
  useSeo({ title: "Events", description: "Wolfdog events, meetups, webinars, and fundraisers." });
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-14">
      <p className="overline text-[#8B6D1F]">Community</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-[#0A192F] mt-1">Events Calendar</h1>
      <p className="mt-4 text-lg text-[#4A5568] max-w-2xl leading-relaxed">
        Find wolfdog events, rescues, educational webinars, and community meetups near you.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 mt-12">
        {events.map((e) => (
          <div key={e.id} data-testid={`event-${e.id}`} className="bg-white border border-[#0A192F]/10 overflow-hidden hover:-translate-y-1 transition-transform">
            <div className="aspect-[16/9] overflow-hidden">
              <img src={e.image_url || FALLBACK_IMAGE} alt={e.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <span className="inline-flex items-center gap-2 overline text-[#8B6D1F]">
                <Calendar className="w-4 h-4" /> {fmt(e.date)}
              </span>
              <h3 className="font-display text-xl font-bold text-[#0A192F] mt-2">{e.title}</h3>
              {e.location && (
                <p className="mt-2 text-sm text-[#4A5568] flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-[#D4AF37]" /> {e.location}
                </p>
              )}
              <p className="mt-3 text-sm text-[#4A5568] leading-relaxed">{e.description}</p>
              {e.link && (
                <a href={e.link} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-1 overline text-[#8B6D1F] hover:underline">
                  Details <ExternalLink className="w-3 h-3" />
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
      {!events.length && <p className="mt-10 text-[#4A5568]">No events scheduled yet. Check back soon.</p>}
    </div>
  );
}
